import { Http,HttpCase} from "../Http";
export class CommontypeAPI {

  public static  getcommontype(input: any){

    var url = "api/getCommonNameByMeterType/CASE_TYPE" ;
 
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;  
  }

  public static  getCommonValue(input: any){

    var url = "/getCommonNameByMeterType?commonName=case_type" ;
   // alert("url"+url);
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpCase.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;  
  }
 
  public static  getallCommontypebyInput(input: any){

    var url = "api/getCommonNameByMeterType/"+input ;
 
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;  
  }

}
